import React from "react";
import { Link } from "react-router-dom";

export const Field = ({ label, htmlFor, optional, hint, error, children, testId }) => (
  <div className="field" data-testid={testId}>
    <label htmlFor={htmlFor} className="field-label">
      {label}
      {optional ? <span className="field-opt"> · optional</span> : null}
    </label>
    {children}
    {error ? (
      <div className="field-error" role="alert" data-testid={`${htmlFor}-error`}>
        {error}
      </div>
    ) : hint ? (
      <div className="field-hint">{hint}</div>
    ) : null}
  </div>
);

export const TextInput = ({ id, name, type = "text", value, onChange, testId, invalid, ...rest }) => (
  <input
    id={id}
    name={name}
    type={type}
    value={value ?? ""}
    onChange={onChange}
    className="field-input"
    aria-invalid={invalid ? "true" : undefined}
    data-testid={testId}
    {...rest}
  />
);

export const Textarea = ({ id, name, rows = 4, value, onChange, testId, invalid, ...rest }) => (
  <textarea
    id={id}
    name={name}
    rows={rows}
    value={value ?? ""}
    onChange={onChange}
    className="field-input field-textarea"
    aria-invalid={invalid ? "true" : undefined}
    data-testid={testId}
    {...rest}
  />
);

export const Select = ({ id, name, value, onChange, options, testId, invalid, ...rest }) => (
  <div className="field-select-wrap">
    <select
      id={id}
      name={name}
      value={value}
      onChange={onChange}
      className="field-input field-select"
      aria-invalid={invalid ? "true" : undefined}
      data-testid={testId}
      {...rest}
    >
      <option value="">Select</option>
      {options.map((o) => (
        <option key={o.value} value={o.value}>
          {o.label}
        </option>
      ))}
    </select>
    <span className="field-select-chev" aria-hidden="true">
      ▾
    </span>
  </div>
);

export const Honeypot = ({ value, onChange }) => (
  <div className="honeypot" aria-hidden="true">
    <label htmlFor="hp">Leave this empty</label>
    <input id="hp" name="hp" type="text" tabIndex={-1} autoComplete="off" value={value ?? ""} onChange={onChange} data-testid="honeypot-input" />
  </div>
);

export const SubmitRow = ({ pending, label, testId, error }) => (
  <div className="form-actions">
    <button type="submit" className="btn btn-accent" disabled={pending} data-testid={testId}>
      {pending ? "Sending…" : label}
    </button>
    <p className="form-privacy" data-testid="form-privacy-line">
      We use what you send only to reply to you.{" "}
      <Link to="/privacy" className="link-accent">
        Privacy
      </Link>
    </p>
    {error ? (
      <div className="form-error" role="alert" data-testid="form-error">
        {error}
      </div>
    ) : null}
  </div>
);

export const Confirmation = ({ children, testId }) => (
  <div className="form-confirmation" role="status" data-testid={testId}>
    {children}
  </div>
);
